import React from "react"

const SharedLessonStudentContext = React.createContext<
  { userId: string; name: string } | undefined
>(undefined)

export function SharedLessonStudentProvider({
  children,
  userId,
  name,
}: {
  children: React.ReactNode
  userId: string
  name: string
}) {
  return (
    <SharedLessonStudentContext.Provider value={{ userId, name }}>
      {children}
    </SharedLessonStudentContext.Provider>
  )
}

export function useSharedLessonStudentContext() {
  return React.useContext(SharedLessonStudentContext)
}
